const config = {
	url: 'https://geoback.uniwebdemo.com/public/bco2/',
	css: 'http://localhost/work/css/'
}

export default config;